(function () {
    /**
     * Check if audioelement is available
     */
        function audioCheck() {
            let audioElement = document.querySelector("audio");
    
            if ($(audioElement).length) {
                console.log("audio exists");
            } else {
                console.log("no audio");
            }
        }
    /**
     * Audio player on profile pages
     * DE and EN samples are loaded in two different functions 
     */
        function player() {
            let loadId_de = document.getElementById("load-de");
            let loadId_en = document.getElementById("load-en");
    
            let playBtnId_de = document.getElementById("play-pause-id-de");
            let playBtnId_en = document.getElementById("play-pause-id-en");
    
            let progressBar;
            let sample_de;
            let sample_en;
            let path;
    
            /**
             * Load function for Audiofile
             * Seperated from play function because we generate the Audio Element
             */
            /**
             * load DE sample
             */
            $(loadId_de).on("click", function (evt) {
                console.log("jo");
                path =
                    document.location.origin +
                    // "/konferenzberatung/dist/" + // Local
                      "/" + // Preview Server
                    $(this).attr("data-src");
                $(this).children().css("display", "none");
    
                $(this).addClass("loader");
                $(this).parent().find(playBtnId_de).removeClass("disabled");
                sample_de = new Audio(path);
                console.log(sample_de);
    
                $(this)
                    .delay(250)
                    .queue(function (next) {
                        $(this).fadeOut("slow");
                        next();
                        $(".icon-play").parent().fadeIn();
                    });
            });
             /**
             * load EN sample
             */
            $(loadId_en).on("click", function (evt) {
                path =
                    document.location.origin +
                    // "/konferenzberatung/dist/" + // Local
                      "/" + // Preview Server
                    $(this).attr("data-src");
                $(this).children().css("display", "none");
    
                $(this).addClass("loader");
                $(this).parent().find(playBtnId_en).removeClass("disabled");
                sample_en = new Audio(path);
                console.log(sample_en);
    
                $(this)
                    .delay(250)
                    .queue(function (next) {
                        $(this).fadeOut("slow");
                        next();
                        $(".icon-play").parent().fadeIn();
                    });
            });
            /**
             * Play and pause functionality
             */
            /**
             * Play and pause DE sample
             */
            $(playBtnId_de).on("click", function (evt) {
                console.log(sample_de);
    
                $(sample_de).on("timeupdate", function () {
                    $(progressBar).css(
                        "width",
                        (sample_de.currentTime / sample_de.duration) * 100 + "%"
                    );
                    console.log(sample_de.currentTime);
                });
                sample_de.onended = function () {
                    $(playBtnId_de).removeClass("icon-stop");
                    $(playBtnId_de).addClass("icon-play");
                };
    
                if (sample_de.paused) {
                    sample_de.play();
                    $(this).removeClass("icon-play");
                    $(this).addClass("icon-stop");
                    progressBar = $(this).parent().parent().find(".progress");
    
                    return progressBar;
                } else {
                    sample_de.pause();
    
                    $(this).removeClass("icon-stop");
                    $(this).addClass("icon-play");
                }
            });
            /**
             * Play and pause EN sample
             */
            $(playBtnId_en).on("click", function (evt) {
                console.log(sample_en);
    
                $(sample_en).on("timeupdate", function () {
                    $(progressBar).css(
                        "width",
                        (sample_en.currentTime / sample_en.duration) * 100 + "%"
                    );
                    console.log(sample_en.currentTime);
                });
                sample_en.onended = function () {
                    $(playBtnId_en).removeClass("icon-stop");
                    $(playBtnId_en).addClass("icon-play");
                };
    
                if (sample_en.paused) {
                    sample_en.play();
                    $(this).removeClass("icon-play");
                    $(this).addClass("icon-stop");
                    progressBar = $(this).parent().parent().find(".progress");
    
                    return progressBar;
                } else {
                    sample_en.pause();
    
                    $(this).removeClass("icon-stop");
                    $(this).addClass("icon-play");
                }
            });
        }
        
        window.addEventListener("load", function () {
            player();
            audioCheck();
        });
    })();
    